import axios from "@/libs/api.request.js";

// 绑定召唤码 - 没用过
export const summon = data => axios.request({ url: "/activity/summon", data, requireToken: true });

// 召回老玩家活动登录 - 新
export const login = data => axios.request({ url: "/activity/recall/login", data, useTemp: true });

// 无感登录 - 新
export const loginByCode = data => axios.request({ url: `/activity/recall/senseless-login`, data, unHint: true, useTemp: true });

// 生成召回码 - 弃用
export const summonWord = params  => axios.request({ url: "/activity/summon/summon-word", params, method: 'get', requireToken: true });

// 玩家信息，包含喵币余额 - 新
export const getUserInfo = template_id  => axios.request({ url: `/activity/recall/user-info`, method: 'get', requireToken: true, useTemp: true });

// 未登录状态下获取喵币列表 - 新
export const getMBList = template_id => axios.request({ url: `/activity/recall/credit-list`, method: 'get', useTemp: true });

// 查询登录用户喵币列表 - 新
export const getLoginMBList = template_id => axios.request({ url: `/activity/recall/credit-list`, method: 'get', requireToken: true, useTemp: true });

// 获取已经找回用户的列表 - 新
export const getBoundUserInfo = template_id => axios.request({ url: `/activity/recall/recall-list`, method: 'get', requireToken: true, useTemp: true });

// 中奖列表 - 新 点击中奖记录
export const lotteryRecord = template_id => axios.request({ url: `/activity/recall/lotteries`, method: 'get', requireToken: true, useTemp: true });

// 消耗喵币抽奖接口 - 新
export const lottery = template_id => axios.request({ url: `/activity/recall/lottery`, method: 'get', requireToken: true, useTemp: true });

// 抽奖选项列表 - 弃用
export const getLotteryOption = () => axios.request({ url: "/activity/summon/lottery-option", method: 'get' });

// 被召回者绑定账号码 - 新 - 确认回归 自主回归
export const bindingCode = (data) => axios.request({ url: "/activity/recall/return", method: 'post', data, requireToken: true, useTemp: true  });

// 领取登录、充值奖励的喵币 - 新 - 喵币列表领取
export const getCoin = data => axios.request({ url: "/activity/recall/credit", method: 'post', data, requireToken: true, useTemp: true  });

// 忘记密码接口 - 不变
export const changeUserPwd = data => axios.request({ url: "/user/changeUserInfo", data  });

// 获取通用类短信验证码 - 不变
export const getSmsCode = data => axios.request({ url: '/user/sendCode', data });

// 红包领取记录 - 弃用
export const redPacketRecord = () => axios.request({ url: '/activity/summon/redpacket-record', method: 'get', requireToken: true, unHint: true });

// 获取红包列表 - 新
export const redPacketList = (template_id, f) => axios.request({ url: `/activity/recall/red-packets`, method: 'get', requireToken: f, unHint: true, useTemp: true });

// 新增红包领取记录 - 新
export const addRecord = data => axios.request({ url: `/activity/recall/red-packet`, method: 'post', data, requireToken: true, useTemp: true });

// 被召回者领取礼包码 - 新
export const getCdKey = () => axios.request({ url: `/activity/recall/join-gift`, requireToken: true, useTemp: true});

// 获取基础模板信息 - 新
export const commonTemplate = (data) => axios.request({ url: `/activity/recall/template`, method: 'get', useTemp: true});

// 获取模板活动信息 - 新
export const commonActivities = (data) => axios.request({ url: `/activity/recall/activities`, method: 'get', useTemp: true});

// 获取模板活动信息-登录 - 新
export const commonActivitiesLogin = (data) => axios.request({ url: `/activity/recall/activities`, requireToken: true, method: 'get', useTemp: true});

// 新增用户联系地址 - 新
export const userAddress = data => axios.request({ url: `/activity/recall/user-address`, method: 'post', data, requireToken: true, useTemp: true });

// 判断模板是否在活动时间内 - 新
export const temlateStatus = data => axios.request({ url: `/activity/recall/template-status`, method: 'get', useTemp: true });
